import {
  Button,
  Text,
  UnderlyingYieldBearingAssetDetailSection,
  UnderlyingYieldBearingAssetListItem,
} from '@/components';
import CarouselSection from '@/components/atoms/CarouselSection/CarouselSection';
import StyledPieChart from '@/components/molecules/Charts/StyledPieChart';
import APP_CONFIG from '@/config/app';
import { UnderlyingYieldBearingAssetInterface } from '@/interfaces/UnderlyingYieldBearingAssetInterface';
import { FC } from 'react';
import { IoSparklesSharp } from 'react-icons/io5';
const ProspectusIcon = IoSparklesSharp as React.ComponentType<any>;
const { MAIN_GAP } = APP_CONFIG.STYLES;
const spacingConfig = {
  gap: `gap${MAIN_GAP}`,
};
interface UnderlyingYieldBearingAssetsDetailCarouselSectionProps {
  underlyingYieldBearingAssets: UnderlyingYieldBearingAssetInterface[];
  showCompositionColor?: boolean;
  showDescription?: boolean;
  showSource?: boolean;
  showAssetDetailsAsChips?: boolean;
  showHistoricalPerformanceCharts?: boolean;
  onBrochureHelpClick?: (
    markdown: string,
    asset: UnderlyingYieldBearingAssetInterface,
  ) => void;
}
const UnderlyingYieldBearingAssetsDetailCarouselSection: FC<
  UnderlyingYieldBearingAssetsDetailCarouselSectionProps
> = ({
  underlyingYieldBearingAssets,
  showCompositionColor: showLeftColor = false,
  showDescription = true,
  showSource = true,
  showAssetDetailsAsChips = false,
  showHistoricalPerformanceCharts = true,
  onBrochureHelpClick,
}) => {
  const availableColors = APP_CONFIG.TOKEN_COLORS;
  const screens = underlyingYieldBearingAssets.map(
    (
      underlyingYieldBearingAsset: UnderlyingYieldBearingAssetInterface,
      index: number,
    ) => {
      const compositionPercentage =
        underlyingYieldBearingAsset.composition <= 1
          ? Math.round(underlyingYieldBearingAsset.composition * 100)
          : Math.round(underlyingYieldBearingAsset.composition);
      const data = [
        { name: 'Composition', value: compositionPercentage },
        { name: 'Rest', value: 100 - compositionPercentage },
      ];
      const handleButtonClick = () => {
        window.open(underlyingYieldBearingAsset.dAppUrl, '_blank');
      };
      const leftColor = showLeftColor
        ? availableColors[index % availableColors.length]
        : undefined;
      return {
        mainHeader: (
          <UnderlyingYieldBearingAssetListItem
            underlyingYieldBearingAsset={underlyingYieldBearingAsset}
            leftColor={leftColor}
          />
        ),
        mainHeaderAlign: 'left' as 'left',
        subHeader: <StyledPieChart key={index} data={data} size={36} />,
        subHeaderAlign: 'right' as 'right',
        body: (
          <div className={`flex flex-col ${spacingConfig.gap}`}>
            {showDescription && (
              <Text value={underlyingYieldBearingAsset.description} />
            )}
            <UnderlyingYieldBearingAssetDetailSection
              underlyingYieldBearingAsset={underlyingYieldBearingAsset}
              showAssetDetailsAsChips={showAssetDetailsAsChips}
              showHistoricalPerformanceCharts={showHistoricalPerformanceCharts}
            />
            <div
              className={`flex flex-row mt-auto w-full ${spacingConfig.gap}`}
            >
              {underlyingYieldBearingAsset.brochureInMarkdown &&
                onBrochureHelpClick && (
                  <Button
                    icon={'ai'}
                    intent="ai"
                    iconStyles={{ intent: 'ai', size: 'md' }}
                    className="w-full"
                    onClick={() =>
                      onBrochureHelpClick(
                        underlyingYieldBearingAsset.brochureInMarkdown || '',
                        underlyingYieldBearingAsset,
                      )
                    }
                  >
                    Research
                  </Button>
                )}
              {showSource && (
                <Button
                  icon="link"
                  iconStyles={{
                    intent: 'accent',
                  }}
                  className="w-full"
                  onClick={handleButtonClick}
                >
                  Source
                </Button>
              )}
            </div>
          </div>
        ),
      };
    },
  );
  return (
    <div className="flex-1 overflow-hidden">
      <CarouselSection
        screens={screens}
        showNavigationControlsInHeader
        leftAlignHeaderWhenNavigationControlsAreShown
      />
    </div>
  );
};
export default UnderlyingYieldBearingAssetsDetailCarouselSection;
